import "./index.css";
import type { ISpinnerProps } from "./types";
import { clsx } from "clsx";

export const Spinner = ({
  size = "sm",
  color = "primary",
  role = "status",
  className,
  translations,
}: ISpinnerProps) => {
  const ariaLabel = translations?.ariaLabel || "Loading";
  const rootClass: string = clsx(
    "nuco-spinner",
    `nuco-spinner--${size}`,
    `nuco-spinner--${color}`,
    className,
  );
  const innerClass: string = clsx("nuco-spinner__inner");

  return (
    <div className={rootClass} aria-label={ariaLabel} role={role}>
      <div className={innerClass} />
    </div>
  );
};
